import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase.js';
import useAuth from '../hooks/useAuth.js';
import { GOLD } from '../constants/colors.js';

export default function AuthAppBarActions() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <Tooltip title="تسجيل الخروج">
      <IconButton onClick={handleLogout} sx={{ color: GOLD }}>
        <LogoutIcon />
      </IconButton>
    </Tooltip>
  );
}
